export default __webpack_public_path__ + "media/color/via-3805ca16.svg";